// english

export default {
  blacklist_title: '黑名单设备列表',
  blacklist_btn_add_device: '添加为新设备',

  // conifrm
  blacklist_confirm_delete_title: '确定删除该条记录？',

  // table
  blacklist_table_sn: 'SN',
  blacklist_table_mac: 'MAC地址',
  blacklist_table_protocol_version: '协议版本',
  blacklist_table_register_time: '注册时间',
};
